
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/cennik-karnetow-narciarskich",
      function () {
        return require("private-next-pages/[region]/[resort]/cennik-karnetow-narciarskich.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/cennik-karnetow-narciarskich"])
      });
    }
  